import React, { useContext } from "react";
import NavContext from "../../Store/nav-ctx";
import DisplayDate from "../Calendar/DisplayDate";
import classes from './SubNavigation.module.css';
import Button from "../UI/Button";
import Select from "react-select";
// eslint-disable-next-line
Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}



const TenantSubNavigation = () => {  
  const navCTX = useContext(NavContext);
  

  const thisDay = navCTX.CurrentDay;
  const nextDay = thisDay.addDays(1);
  const prevDay = thisDay.addDays(-1);
  const tenants = navCTX.TenantList;
  console.log("rendering SubNavigation - tenants");

  const changeSelectedTenant = (selectedTenant) => 
  {
    console.log('chaning current tenant to : ' + selectedTenant.value);
    navCTX.onChangeCurrentTenant(selectedTenant.value);
  };
  const tenantOptions = tenants ? tenants.map( (tenant)=> ({value: tenant.TenantID, label: tenant.TenantName})) : console.error('no tenant List');
  //console.log("room options: " + roomsOptions);
  console.log("Navigation: " + thisDay + " to "  +nextDay);
   return (
    <div className={classes.subnav}>
        <Button onClick={() => {navCTX.onChangeDay(prevDay)}} className="buttonRect">Prev</Button>        
         <DisplayDate currentDate={navCTX.CurrentDay}></DisplayDate>
         <div tabIndex={-1}>
         <Select inputProps={{ readOnly: true }} isSearchable={ false } className={classes.selectBox} options={tenantOptions} onChange={changeSelectedTenant} value={tenantOptions ? tenantOptions.filter(function(option) {return option.value === navCTX.CurrentTenant}): null}></Select>
         </div>
        <Button onClick={() => {navCTX.onChangeDay(nextDay)}}>next</Button>
    </div>
  ) 
  };

  // {navCTX.onChangeDay(new Date(navCTX.CurrentDay+1))}
  // value={options.filter(item => item.value === navCTX.CurrentRoom)} onChange={SetSelectedRoom}
export default TenantSubNavigation;